<template>
  <div class="container">
    <div class="box">
      <img
        class="icon"
        src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/common/16988.png"
        alt=""
        @click="toIndex"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "UserHeader",
  data() {
    return {};
  },
  methods:{
     toIndex(){
      // 前往个人中心页面
      this.$router.push('/')
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_common.scss";
.container {
  height: 129px;
  width: 100%;
  padding-left: 360px;
  // border-bottom: 1px solid #61a842;
  display: flex;
  align-items: center;
  img {
    height: 40px;
    width: 420px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/UserHeader.vue